import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';

@Injectable()
export class PusherService {

    pusher = null;
    pusher_channel = null;

    constructor(
        public http: HttpClient
        ) {}

    public init(site_name, server_name, access_token) {
        if (this.pusher) {
            this.pusher.disconnect();
        }

        /* FUTURE: to use different clusters, would need separate pusher apps (and api keys) and api calls on server would need to call cluster urls
        let cluster = "mt1";
        if(server_name === "mel-2") {
            cluster = "ap4";
        }
        if(server_name === "stl-2") {
            cluster = "mt1";
        } */

        this.pusher = new Pusher('2c65d02bc6540199e127', {
            authEndpoint: 'https://' + site_name + '.airsquare.com/api/pusherauth?access_token=' + access_token
        });
        this.pusher_channel = this.pusher.subscribe('private-site-' + site_name);
        return this.pusher_channel;
    }

    public disconnect() {
        if (this.pusher) {
            this.pusher.disconnect();
        }
    }

}
